import React, { useContext, useState, useRef } from 'react';
import AppContext from '../../context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPencilAlt,
  faBars,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import { Overlay, Popover } from 'react-bootstrap';
import { Number, RenamePfForm, ClearPf, DeletePf } from '../common/common';
import { fetchGain } from '../../../api';
import { ReactComponent as ThreeDots } from '../../../assets/icons/three-dots.svg';
import { ReactComponent as ThreeDotsMob } from '../../../assets/icons/three-dots-mob.svg';
import { ReactComponent as Refresh } from '../../../assets/icons/refresh.svg';
import { ReactComponent as RefreshMob } from '../../../assets/icons/refresh-mob.svg';
import { ReactComponent as AngleDownRed } from '../../../assets/icons/angle-down-red.svg';
import { ReactComponent as AngleUpGreen } from '../../../assets/icons/angle-up-green.svg';
import { ReactComponent as DropdownAngleDown } from '../../../assets/icons/dropdown-angle-down.svg';
import { ReactComponent as DropdownAngleUp } from '../../../assets/icons/dropdown-angle-up.svg';
import { ReactComponent as DropdownAngleDownMob } from '../../../assets/icons/dropdown-angle-down-mob.svg';
import { ReactComponent as DropdownAngleUpMob } from '../../../assets/icons/dropdown-angle-up-mob.svg';
import CustomRangedGain from './custom_ranged_gain/custom_ranged_gain.component';

const SummaryTable = (props) => {
  const context = useContext(AppContext);
  //state
  const [isSettingsVisible, setIsSettingsVisible] = useState(false);
  const [isRenamePfModalVisible, setIsRenamePfModalVisible] = useState(false);
  const [isClearPfModalVisible, setIsClearPfModalVisible] = useState(false);
  const [isDeletePfModalVisible, setIsDeletePfModalVisible] = useState(false);
  const settingsIcon = useRef(null);

  //mobile
  const [isCollapsed, setIsCollapsed] = useState(
    window.innerWidth <= 480 ? true : false,
  );

  function get_data_class(data) {
    let color_class = '';
    if (data !== 0) {
      color_class = data < 0 ? 'c-negative negative' : 'c-positive positive';
    }
    return color_class + ' data';
  }

  const settingsPopover = (
    <Popover id="settings" className="settings-popover">
      <Popover.Content className="pf-settings">
        <div
          className="item"
          onClick={() => {
            setIsSettingsVisible(false);
            setIsRenamePfModalVisible(true);
          }}
        >
          <FontAwesomeIcon icon={faPencilAlt} />
          Rename Portfolio
        </div>
        {!props.pf.is_mf_sync_in_progress && (
          <div
            className="item"
            onClick={() => {
              setIsSettingsVisible(false);
              setIsClearPfModalVisible(true);
            }}
          >
            <FontAwesomeIcon icon={faBars} />
            Clear Portfolio
          </div>
        )}
        {context.portfolios.filter((pf) => !pf.is_dummy && pf.id !== 'family')
          .length > 1 &&
          !props.pf.is_mf_sync_in_progress && (
            <>
              <div
                className="item"
                onClick={() => {
                  setIsSettingsVisible(false);
                  setIsDeletePfModalVisible(true);
                }}
              >
                <FontAwesomeIcon icon={faTrashAlt} />
                Delete Portfolio
              </div>
            </>
          )}
      </Popover.Content>
    </Popover>
  );

  return (
    <section className="summary_container">
      <div className="summary-item pf-name__cont">
        <div className="pf_name">{props.pf.name}</div>
      </div>
      <div
        className={`summary_items__container ${isCollapsed ? 'hidden' : ''}`}
      >
        <div className="summary-item net_worth">
          <div className="head">Net Worth</div>
          <div className="data">
            <Number
              value={props.current_value}
              usePrefix={true}
              format={true}
              isFormatWeb={true}
            />
          </div>
        </div>
        <div className="summary-item gain">
          {!!props.pf.broker ||
          props.pf.id === 'family' ||
          props.pf.is_empty ||
          props.pf.has_mfs ? (
            <>
              <div className="head">Today's Gain</div>
              <div className={get_data_class(props.one_day_change)}>
                <Number
                  value={props.one_day_change}
                  usePrefix={true}
                  format={true}
                  isFormatWeb={true}
                />
              </div>
            </>
          ) : (
            <CustomRangedGain
              defaultValue={props.one_day_change}
              minStartDate={props.inception_date}
              api={fetchGain}
              portfolioId={props.pf.id}
            />
          )}
        </div>
        <div className="summary-item total_gain">
          <div className="head">
            {props.pf.has_mfs && !props.pf.has_equity_or_etf
              ? "MF's Gain"
              : 'Total Gain'}
          </div>
          <div className={get_data_class(props.gain_loss)}>
            <Number
              value={props.gain_loss}
              usePrefix={true}
              format={true}
              isFormatWeb={true}
            />
            <div className="change_perc">
              <div>
                {props.returnsType === 'xirr'
                  ? props.gain_loss_perc
                  : props.gain_loss_abs_perc}
                %
              </div>
              <div>
                {props.gain_loss ? (
                  props.gain_loss > 0 ? (
                    <AngleUpGreen />
                  ) : (
                    <AngleDownRed />
                  )
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="summary_btns">
        {!context.is_sample && (
          <>
            {(!!props.pf.broker ||
              props.pf.has_mfs ||
              props.pf.is_mf_sync_in_progress) && (
              <button
                type="button"
                className="sync_btn"
                onClick={() => {
                  props.setCurrentPf(props.pf);
                  if (props.pf.broker && props.pf.has_mfs) {
                    props.setShowSyncBrokerMF(true);
                    return;
                  }
                  if (props.pf.has_mfs) {
                    props.setShowImportMFs(true);
                    return;
                  }
                  props.setManagePfFrom('sync_from_summary');
                  props.setShowManagePf(true);
                }}
                disabled={props.pf.is_mf_sync_in_progress}
                title={
                  props.pf.is_mf_sync_in_progress
                    ? 'Your Mutual Funds are being fetched'
                    : 'Resync Portfolio'
                }
              >
                <span
                  className={`refresh_icon ${
                    props.pf.is_mf_sync_in_progress ? 'fetching_icon' : ''
                  }`}
                >
                  <Refresh />
                </span>
                <span
                  className={`refresh_icon_mob ${
                    props.pf.is_mf_sync_in_progress ? 'fetching_icon' : ''
                  }`}
                >
                  <RefreshMob />
                </span>
              </button>
            )}
            <div className={`summary-item three_dots ${props.pf.id}`}>
              <>
                <div
                  className="three_dots__cont"
                  ref={settingsIcon}
                  onClick={() => setIsSettingsVisible(!isSettingsVisible)}
                >
                  <span className="three_dots">
                    <ThreeDots />
                  </span>
                </div>
                <Overlay
                  rootClose={true}
                  placement="bottom"
                  target={settingsIcon.current}
                  show={isSettingsVisible}
                  onHide={() => setIsSettingsVisible(false)}
                  //rootCloseEvent={() => setIsSettingsVisible(false)}
                >
                  {settingsPopover}
                </Overlay>
                {!context.is_sample && props.pf && (
                  <>
                    <RenamePfForm
                      show={isRenamePfModalVisible}
                      setShow={setIsRenamePfModalVisible}
                      pf={props.pf}
                      setContext={props.setContext}
                    />
                    {!props.pf.is_mf_sync_in_progress && (
                      <ClearPf
                        show={isClearPfModalVisible}
                        setShow={setIsClearPfModalVisible}
                        pf={props.pf}
                        setContext={props.setContext}
                      />
                    )}
                    {context.portfolios.filter(
                      (pf) => !pf.is_dummy && pf.id !== 'family',
                    ).length > 1 &&
                      !props.pf.is_mf_sync_in_progress && (
                        <>
                          <DeletePf
                            show={isDeletePfModalVisible}
                            setShow={setIsDeletePfModalVisible}
                            pf={props.pf}
                            setContext={props.setContext}
                          />
                        </>
                      )}
                  </>
                )}
              </>
            </div>
          </>
        )}
        <button
          type="button"
          className={`summary_toggler`}
          onClick={() => setIsCollapsed(!isCollapsed)}
        >
          <span className="dropdown_angle">
            {isCollapsed ? <DropdownAngleDown /> : <DropdownAngleUp />}
          </span>
          <span className="dropdown_angle_mob">
            {isCollapsed ? <DropdownAngleDownMob /> : <DropdownAngleUpMob />}
          </span>
        </button>
      </div>
    </section>
  );
};

export default SummaryTable;
